/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_EmptyInputs */

const en_directory_external_directories_empty = /** @type {(inputs: Directory_External_Directories_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No directories match this filter yet.`)
};

const zh_directory_external_directories_empty = /** @type {(inputs: Directory_External_Directories_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该筛选下暂无目录。`)
};

/**
* | output |
* | --- |
* | "No directories match this filter yet." |
*
* @param {Directory_External_Directories_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_empty = /** @type {((inputs?: Directory_External_Directories_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_empty(inputs)
	return zh_directory_external_directories_empty(inputs)
});
export { directory_external_directories_empty as "directory.external_directories.empty" }